<template>
  <section v-loading.fullscreen.lock="loading" class="room">
    <el-backtop target=".room" :bottom="100" :visibility-height="1" />
    <div class="room-search bar">
      <div v-for="(item,index) in searchData" :key="index" style="margin-top:10px">
        <el-button class="titles" :class="requestParams2.category_1 == null ? 'activeTab' :''" @click="handleSearch(null,'title')">
          学段 :
        </el-button>
        <section class="content">
          <el-button
            v-for="item1 in item.children" :key="item1.id"
            :class="requestParams2.category_1 == item1.id ? 'activeTab' :''"
            @click="handleSearch(item1.id,'classify1')">
            {{ item1.name }}
          </el-button>
        </section>
      </div>
      <section v-if="classify2">
        <div v-for="(item,index) in classify2" :key="index">
          <el-button class="titles" :class="requestParams2.category_2 == null ? 'activeTab' :''" @click="handleSearch(null,'kinds')">
            类型 :
          </el-button>
          <section class="content">
            <el-button
              v-for="item1 in item.children"
              :key="item1.id"
              :class="requestParams2.category_2 == item1.id ? 'activeTab' :''"
              @click="handleSearch(item1.id,'classify2')">
              {{ item1.name }}
            </el-button>
          </section>
        </div>
      </section>
      <section>
        <div v-for="(item,index) in classify3" :key="index">
          <section v-if="item.children" class="classify3content">
            <el-button class="titles" :class="requestParams2.category_3 == null ? 'activeTab' :''" @click="handleSearch(null,'classroom')">
              教室 :
            </el-button>
            <section class="content">
              <el-button
                v-for="item1 in item.children"
                :key="item1.id"
                :class="requestParams2.category_3 == item1.id ? 'activeTab' :''"
                @click="handleSearch(item1.id,'classify3')">
                {{ item1.name }}
              </el-button>
            </section>
          </section>
        </div>
      </section>
    </div>
    <div class="room-title">
      <com-tabs
        :list="squareInfo.obj.tabs"
        class="room-tabs"
        :default-tab="activeTab"
        @change="changeTab"
      >
        <template v-slot:text="{ obj }">
          <div
            :class="{ activeTab: activeTab == obj.key }"
            class="room-tabs-item"
          >
            <img
              :src="
                require(`@/assets/icon/icon-${
                  obj.name == '漫游' ? 'roam3' : 'img3'
                }.png`)
              "
              alt=""
            >
            <span>{{ obj.name }}</span>
          </div>
        </template>
      </com-tabs>
    </div>
    <div v-if="activeTab == 0" class="room-data">
      <div v-for="(item2) in data1.data" :key="item2.id" class="cell-item">
        <com-card2
          :obj="item2"
          style="margin-right: 15px; margin-top: 20px"
          img-height="215px"
          :is-img="!item2.video"
          :is-edit="false"
          @control="handleControl"
          @control1="handleRouteDto"
          @path="handleRouteDto"
        />
        <!-- <com-card
          :dtoObj="item2"
          @path="handleRouteDto"
          :showControl="false"
          imgHeight="215px"
          :isImg="!item2.video"
        >
        </com-card> -->
      </div>
      <div class="zhanwei" />
      <div class="zhanwei" />
      <div class="p-contianer">
        <el-pagination
          :page="requestParams2.page"
          :page-size="requestParams2.page_size"
          :pager-count="11"
          layout="total,prev, pager, next,jumper"
          :total="data1.total||0"
          background
          @current-change="handleCurrentChange1"

        />
      </div>
    </div>
    <div v-else class="room-data">
      <template v-if="data3.data.length !=0">
        <div v-for="(item3, index3) in data3.data" :key="index3" class="cell-item">
          <com-card2
            class="comCard2"
            :obj="item3"
            img-height="215px"
            style="margin-right: 15px; margin-top: 20px"
            :is-img="!item3.video"
            :is-edit="false"
            @control="handleControl"
            @control1="handleRouteDto"
            @path="handleRouteDto"
          />
        </div>
        <div class="zhanwei" />
        <div class="zhanwei" />
        <div class="p-contianer">
          <el-pagination
            :page="requestParams3.page"
            :page-size="requestParams3.page_size"
            :pager-count="11"
            layout="total,prev, pager, next,jumper"
            :total="data3.total||0"
            background
            @current-change="handleCurrentChange3"
          />
        </div>
      </template>
      <template v-else>
        <div class="nullData">
          暂无收藏数据
        </div>
      </template>
    </div>
    <div v-if="dialogVisible">
      <el-dialog
        title="详情展示"
        :visible.sync="dialogVisible"
        fullscreen
      >
        <iframe :src="this.src" frameborder="0" width="100%" height="100%" />
      </el-dialog>
    </div>
  </section>
</template>

<script>
import api from '@/api/app'
import mock from '@/utils/mock'
import comCard2 from '@/components/comCard2'
import comTabs from '@/components/comTabs'
// import comCard from "@/components/comCard/index.vue";
export default {
  components: {
    comCard2,
    comTabs
    // comCard,
  },
  data() {
    return {
      squareInfo: mock.square.square.viewInfo,
      roomInfo: mock.room.room.viewInfo,
      roomInit: mock.room.room.init,
      requestParams2: {
        page: 1,
        page_size: 9
      },
      requestParams: {
        collection_id: null,
        collection_type: 3
      },
      requestParams3: {
        collection_type: 3,
        page: 1,
        page_size: 9
      },
      data1: [],
      data3: [],
      loading: false,
      activeTab: 0,
      requestParams4: {
        collection_id: null,
        collection_type: 3
      },
      src: '',
      dialogVisible: false,
      searchData: null,
      classify2: null,
      classify3: null,
      params: {
        category_id: null
      }
    }
  },
  computed: {},
  created() {
    // this.init()
    this.handleSearch()
  },
  mounted() {
    this.loading = true
  },
  methods: {
    async handleSearch(v, x, y, z) {
      this.params.category_id = v
      var obj = {}
      obj.category_id = v
      api.square.retrieve.conditions(obj).then((res) => {
        if (x == undefined) {
          this.searchData = res.data
        } else if (x == 'classify1') {
          this.classify2 = res.data
          this.requestParams2.category_1 = v
          this.requestParams2.category_2 = null
          this.requestParams2.category_3 = null
          this.classify3 = null
        } else if (x == 'classify2') {
          this.classify3 = res.data
          this.requestParams2.category_2 = v
          this.requestParams2.category_3 = null
        } else if (x == 'title') {
          this.requestParams2.category_1 = null
          this.classify2 = null
          this.classify3 = null
          this.requestParams2.category_3 = null
          this.requestParams2.category_2 = null
        } else if (x == 'classify3') {
          this.requestParams2.category_3 = v
        } else if (x == 'kinds') {
          this.requestParams2.category_2 = null
        } else if (x == 'classroom') {
          this.requestParams2.category_3 = null
        }
        this.init()
      })
    },
    handleControl1(v) {
      this.requestParams4.collection_id = v.id
      const obj = {}
      obj.design_id = v.new_design_id
      obj.dest = 1
      api.square.update.dto(obj).then((res) => {
        this.$router.push({
          path: '/square/set',
          query: {
            src: res.data.url
          }
        })
      })
    },
    handleControl(v) {
      console.log(v, 'v')
      this.requestParams4.collection_id = v.id
      if (v.is_collection == 0) {
        this.$confirm('确认收藏吗?', '提示', {})
          .then(() => {
            api.mine.create.collect(this.requestParams4).then((res) => {
              this.$message.success('收藏成功')
              this.init()
            })
          })
          .catch(() => {})
      } else {
        if (!v.collection_id) {
          this.requestParams4.collection_id = v.id
        } else {
          this.requestParams4.collection_id = v.collection_id
        }
        this.$confirm('确认取消收藏吗?', '提示', {})
          .then(() => {
            console.log(this.requestParams4, v, 'sfksjdfoij')
            api.mine.delete.collect(this.requestParams4).then((res) => {
              this.$message.success('取消收藏成功')
              this.init()
            })
          })
          .catch(() => {})
      }
    },
    changeTab(x, y) {
      this.activeTab = x
      this.init()
    },
    async init() {
      this.loading = true
      // this.data1 = await this.roomInit.spaces(this.params)
      // var collectList = []
      // collectList = this.data1.filter((item, index) => {
      //   return item.is_collection
      // })
      // this.data3 = collectList.reverse()
      if (this.activeTab == 0) {
        this.data1 = await this.roomInit.spaces(this.requestParams2)
      } else {
        this.data3 = await this.roomInit.spaces1(this.requestParams3)
      }

      this.loading = false
    },
    handleRouteDto(v) {
      this.src = v.vr_url
      if (this.src) {
        this.dialogVisible = true
      } else {
        this.$message.info('该案例空间暂无全景！')
      }
      // this.$router.push({
      //   path: '/room/roam',
      //   query: {
      //     src: v.vr_url
      //   }
      // })
    },
    control(type, condition) {
      return mock.system.global.control[type](condition)
    },
    handleCurrentChange1(val) {
      this.requestParams2.page = val
      this.init()
    },
    handleCurrentChange3(val) {
      this.requestParams3.page = val
      this.init()
    }
  }
}
</script>
<style>
.is-fullscreen .el-dialog__body{
  height:calc(100% - 60px);
}
</style>
<style scoped lang="scss">
.room {
  background-color: #f6f6f6;
  padding: 0 34px 10px 34px;
  // overflow-y: scroll;
  // height: calc(100vh - 120px);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  &-search {
    background-color: #fff;
    border-radius: 22px;
    width: $xr-min-width;
    // margin-left: 17%;
    padding: 20px;
    margin-top: 20px;
  }
.bar {
  .titles{
    font-weight: bolder;
    color: #333;
  }
  .content{
        width: 92%;
    display: inline-block;
  }
  .classify3content{
    display: flex;
    align-items: flex-start;
  }
   div {
    display: flex;
    align-items: flex-start;
    margin-bottom: 10px;
     button {
      margin-left: 10px;
      @include fun-design(8);
      border: none;
      padding: 10px !important;
    }
    .activeTab {
      margin-left: 10px;
      border-radius: 18px;
      font-size: 14px;
      @include fun-design(2)
    }
  }
}
  &-title {
    height: 78px;
    background-color: #f6f6f6;
    width: 100%;
    position: sticky;
    top: 0;
    margin: 0 auto;
    flex-shrink: 0;
  }
  &-tabs {
    position: relative;
    top: 20px;
    left: 50%;
    margin-left: -112px;
    margin-top: 20px;
    width: calc(66% - 20px);
    background-color: #4c4c4c;
    border-radius: 22px;
    position: relative;
    width: 224px;
    height: 40px;
    line-height: 40px;
    overflow: hidden;
    &-item {
      position: absolute;
      cursor: pointer;
      width: 120px;
      text-align: center;
      font-size: 18px;
      color: #666;
      margin-top: -2px;
      border-radius: 22px;
      display: flex;
      align-items: center;
      justify-content: center;
      > span {
        display: inline-block;
        text-align: center;
        border-top-left-radius: 22px;
        border-bottom-left-radius: 22px;
        font-family: "AdobeHeitiStd-Regular";
        font-size: 14px;
        color: #fff;
        > img {
          margin-right: 6px;
        }
      }
    }
    .activeTab {
      width: 120px;
      border-radius: 22px !important;
      background-color: #2f82ff !important;
      z-index: 999;
      height: 42px;
      line-height: 42px
    }
  }
  &-data {
    @include fun-layout();
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-between;
    flex: 1;
  }
}
.cell-item /deep/ .card1-content {
  padding: 5% 2%;
  margin-right: 20px;
}
.cell-item /deep/ .card1-img {
  margin-right: 20px;
}
.cell-item {
  width: 33%;
  min-height: 304.062px;
}
.zhanwei{
  width: 33%;
  height: 0;
}
.room /deep/ .vjs-tech {
  object-fit: cover;
  height: 215px;
}
.nullData{
  margin: 0 auto;
  margin-top: 10vh;
  color: #909399;
}
// 分页
.p-contianer {
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 44px;
    margin-top: 10px;
    background-color: #f5f6f9;
    border: none;
    .p-bar {
        float: right;
        margin: 5px 100px 0 0;
    }
}
</style>
